import clsx from 'clsx';
import Link from 'next/link';
import DallasText from '../Text/DallasText';
import DallasSvgIconCloseOutlined from '../Icons/DallasSvgIconCloseOutlined';
import useTimeout from '~/app/_ui/shared/useTimeout';
import { DallasSnackbarPayload } from './DallasSnackbarPayload';

import styles from './DallasSnackbar.module.scss';
import DallasStack from '../Stack/DallasStack';

type Props = DallasSnackbarPayload;

const AUTO_DISMISS_DELAY_MS = 6000;

export default function DallasSnackbar({
  color = 'default',
  addOnStart,
  header,
  subheader,
  action,
  onDismiss,
  autoDismiss,
}: Props) {
  useTimeout(() => onDismiss?.(), autoDismiss ? AUTO_DISMISS_DELAY_MS : null);

  return (
    <DallasStack
      className={clsx(styles.root, styles[`color-${color}`])}
      gap="2xl"
      paddingVertical="xs"
      paddingHorizontal="sm"
      alignVertical="center"
      direction="row"
      paddingEnd={action != null ? 'md' : 'none'}
    >
      {addOnStart && <div className={styles.addOnWrapper}>{addOnStart}</div>}
      <DallasStack direction="column" gap="none" flex>
        <DallasText className={styles.header}>{header}</DallasText>
        {subheader && (
          <DallasText className={styles.subheader} variant="captionL">
            {subheader}
          </DallasText>
        )}
      </DallasStack>
      {action != null ? (
        'href' in action ? (
          <Link
            className={styles.actionButton}
            href={action.href}
            onClick={action.onClick}
          >
            {action.label}
          </Link>
        ) : (
          <button
            className={styles.actionButton}
            type="button"
            onClick={action.onClick}
          >
            {action.label}
          </button>
        )
      ) : (
        onDismiss != null && (
          <button
            className={styles.dismissButton}
            onClick={onDismiss}
            type="button"
            aria-label="Dismiss"
          >
            <DallasSvgIconCloseOutlined />
          </button>
        )
      )}
    </DallasStack>
  );
}
